<template>
	<ValidationProvider
		ref="validationProvider"
		v-slot="{ errors, classes }"
		:mode="mode"
		:rules="rules"
		:vid="vid"
		:name="name"
		slim
	>
		<input
			v-model="inputValue"
			:placeholder="placeholder"
			:class="{ ...classes, ...classObject }"
			class="regular-input"
			:readonly="readonly"
			:type="type"
			@keyup.enter="onSubmit"
		>
		<div
			v-if="$_showErrors(errors, classes)"
			class="input-message"
		>
			<span data-cy="error-message">{{ errors[0] }}</span>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
	name: 'AppInput',

	components: {
		ValidationProvider,
	},

	props: {
		value: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		size: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: '',
		},
		readonly: {
			type: Boolean,
		},
		type: {
			type: String,
			default: 'text',
		},
		mode: {
			type: [String, Function],
			default: 'eager',
		},
		vid: {
			type: String,
			default: '',
		},
		rules: {
			type: [String, Object],
			default: '',
		},
		name: {
			type: String,
			default: 'Field',
		},
	},

	computed: {
		inputValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		classObject() {
			return {
				'is-small': this.size === 'small',
				'is-medium': this.size === 'medium',
				'is-fullwidth': this.size === 'full',
				'is-transparent': this.color === 'none',
				'has-underline': this.color === 'underline',
				'has-underline-light': this.color === 'underline-light',
			};
		},
	},

	methods: {
		$_showErrors(errors, classes) {
			const hasErrors = errors.length > 0;

			if (this.mode === 'aggressive-touch') {
				return hasErrors && classes.touched;
			}

			return hasErrors;
		},

		onSubmit() {
			this.$emit('submit');
		},
	},
};
</script>

<style lang="scss" scoped>
.input-message {
	font-size: $size-7;
	margin: $gap-05;
	color: $color-error;
}

.regular-input {
	padding: 0 15px;
	height: 48px;
    font-size: $size-6;
	font-weight: $fontWeight-regular;
    color: $color-black;
	border-radius: 8px;
    border: 1px solid $color-accent-300;
    outline: none;
    transition: 475ms;

    &::placeholder {
		color: $color-accent-400;
		font-size: $size-6;
    }

    &:hover {
        border-color: $color-accent-400;
    }

    &:focus {
        border-color: $color-accent-400;
	}

	&.is-small {
		width: calc(280px - 30px);
	}

	&.is-medium {
		width: calc(486px - 30px);
	}

	&.is-fullwidth {
		width: calc(100% - 30px);
	}

	&.is-transparent {
		border: none;
		padding: 0;
		border-radius: 0;
		background-color: transparent;
		color: $color-white;
	}

	&.has-underline {
		height: 42px;
		border: none;
		width: 100%;
		padding: 0;
		border-radius: 0;
		border-bottom: 2px solid $color-accent-500;
		background-color: transparent;
		color: $color-accent-200;

		&::placeholder {
			color: $color-accent-400;
		}
	}

	&.has-underline-light {
		height: 42px;
		border: none;
		padding: 0;
		border-radius: 0;
		border-bottom: 2px solid $color-accent-400;
		background-color: transparent;
		color: $color-accent-200;

		&::placeholder {
			color: $color-accent-400;
		}
	}
}
</style>
